import React from 'react';

import './CardAuth.scss';

export const CardAuth = ({ title, description, children }) => {
  return (
    <div className='auth-card'>
      <div className='auth-container'>
        <div className='auth-left'>
          <div className='logo-container'>
            <img src="/media/login_logo.png" alt="SWIM PILOT" className='logo-image' />
          </div>
        </div>
        <div className='auth-right'>
          <div className='login-container'>
            <div className='header'>
              <div className='app-name'>TeamPilot</div>
              <div className='title'>{ title }</div>
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
